(function ($) {

  $(document).ready(function () {
      if($(".gallery-with-content").length > 0){

        setTimeout(function () {
            $(".gallery-with-content .slider-for").css({"opacity": "1"});
            $(".gallery-with-content .slider-nav").css({"opacity": "1"});
        }, 500);
          $('.gallery-with-content .slider-for').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              fade: true,
              asNavFor: '.slider-nav',
              infinite: false
          });
          $('.gallery-with-content .slider-nav').slick({
              slidesToShow: 5,
              slidesToScroll: 1,
              asNavFor: '.slider-for',
              dots: false,
              arrows: false,
              centerMode: false,
              focusOnSelect: true,
              infinite: false
          });

          $(".gallery-with-content .view-more").click(function() {
              var elem = $(this).text();
              if (elem == "View More") {
                  //Stuff to do when btn is in the read more state
                  $(this).text("View Less");
                  $(this).parent().find(".text-outer").addClass("active");
              } else {
                  //Stuff to do when btn is in the read less state
                  $(this).text("View More");
                  $(this).parent().find(".text-outer").removeClass("active");
              }
          });
      }
  });

})(jQuery);